import React, { useMemo } from "react";
import { ChakraProvider, extendTheme, CSSReset } from "@chakra-ui/react";

import { usePublisherThemeConfig } from "./PublisherThemeConfig";
import baseTheme, { withPublisherThemeConfig } from ".";

export default function PublisherThemeExtendedChakraProvider({ children }) {
  const { themeConfig } = usePublisherThemeConfig();

  // Extend the base theme with our publishers theme config (if provided)
  const theme = useMemo(
    () => extendTheme(baseTheme, withPublisherThemeConfig(themeConfig)),
    [themeConfig]
  );

  return (
    <ChakraProvider theme={theme}>
      <>
        <CSSReset />
        {children}
      </>
    </ChakraProvider>
  );
}
